module.exports = __webpack_public_path__ + "static/media/butt08.0fc8b2a3.png";